import styled from 'styled-components';
import Button from '../../Button';
import { IoClose } from 'react-icons/io5';
import {primaryColor} from "../../../config/colors";

export const IdCardWrapper = styled.div`
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  padding-bottom: 60px;
`;

export const TitleAndCommandsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const CurrentLayoutActionContainer = styled.div`
  max-width: 30%;
  margin: 40px 3rem;
`;

export const TitlesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  margin-left: 65px;
  margin-bottom: 30px;
  padding: 0;
  flex-grow: 1;
  flex-wrap: wrap;
  p:not(:last-of-type) {
    margin-bottom: 15px;
  }
`;

export const IdCardTitle = styled.h1`
  margin: 0px;
  margin-bottom: 15px;
  font-weight: 500;
  font-size: 1.8rem;
  display: inline-flex;
`;

export const ModuleTitle = styled.div`
  font-weight: 500;
  font-size: 1.25rem;
  display: inline-flex;
  margin-bottom: 12px;
`;

export const ModuleTitleClickable = styled(ModuleTitle)`
  cursor: pointer;
  &:hover {
    color: ${primaryColor};
  }
`;

export const CommandsWrapper = styled.div`
  display: flex;
  padding: 4px;
  position: relative;
  position: relative;
  justify-content: end;
  position: sticky;
`;

export const PrintButton = styled(Button).attrs({
    wrapperStyle: {
        width: '84px',
        height: '32px',
        marginRight: '10px',
        marginTop: '10px',
    },
})``;

export const ExitButton = styled(Button).attrs({
    wrapperStyle: {
        width: '42px',
        height: '42px',
        marginTop: '5px',
    },
    type: 'rounded',
    icon: IoClose,
    iconProps: {
        color: 'white',
        size: '22px',
    },
})``;

export const EditButton = styled(Button).attrs({
    wrapperStyle: {
        width: '84px',
        height: '32px',
        marginRight: '10px',
        marginTop: '10px',
    },
})``;

export const DetailsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  padding-left: 50px;
  padding-right: 85px;
`;

export const TextualDetailsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-right: 30px;
`;

export const VisualDetailsWrapper = styled.div`
  min-height: 520px;
  max-height: 520px;
  flex: 1;
  flex-direction: column;
`;

export const SectionTitle = styled(ModuleTitle)`
  margin-left: 15px;
`;

export const SectionTitleEl = styled.div`
  display: inline-block;
  min-width: 380px;
`;

export const SubMenusWrapper = styled.ul`
  display: flex;
  flex: 1;
  flex-direction: column;

  margin-top: 20px;
`;

export const PhysicalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex-grow: 1;
`;

export const SecondarySystemWrapper = styled.div`
  padding: 15px;
  background-color: #f4f4fc;
  margin: 6px 0px;
`;

export const SlotLoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
`;

export const OriginalCharacteristics = styled.div`
  font-size: 10px;
  white-space: pre-line;
`;

export const OriginalCharacteristicsWrapper = styled.div`
  padding: 1em;
  border: 1px dashed #aaa;
    display:none;
`;
